// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "b5f771981a995164","396": "a19011c3985ef073","460": "261f2382131d1360","917": "7eedddc0a5e822ef","985": "c7775c0d613d461b",}[chunkId] + ".chunk.js"
}